import { useEffect, useState } from 'react';
import { handleAuth0RedirectCallback } from '../auth/auth0Client';
import { vscodeTheme } from '../styles/theme';

export function Auth0Callback() {
  const [message, setMessage] = useState('Auth0認証処理中です…');

  useEffect(() => {
    let isMounted = true;

    const handleCallback = async () => {
      try {
        const result = await handleAuth0RedirectCallback();
        const returnTo = result?.appState?.returnTo ?? '/';
        if (!isMounted) {
          return;
        }
        setMessage('認証が完了しました。元の画面へ戻ります…');
        window.location.replace(returnTo);
      } catch (error) {
        if (!isMounted) {
          return;
        }
        const errorMessage = error instanceof Error ? error.message : '不明なエラー';
        setMessage(`Auth0認証に失敗しました: ${errorMessage}`);
      }
    };

    void handleCallback();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div
      style={{
        backgroundColor: vscodeTheme.colors.editorBackground,
        color: vscodeTheme.colors.textPrimary,
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: vscodeTheme.typography.fontFamily,
        padding: '24px',
        textAlign: 'center',
      }}
    >
      <div style={{ maxWidth: '520px' }}>
        <h1 style={{ fontSize: '20px', marginBottom: '12px' }}>Auth0認証</h1>
        <p style={{ color: vscodeTheme.colors.textSecondary }}>{message}</p>
      </div>
    </div>
  );
}
